import { CancelTokenSource } from 'axios';
import { OrderedMap, Map, Record } from 'immutable';
import { OrderingRuleType } from '../../interface';

export const key = 'objects';

export type InstanceType = {
	inProgress: boolean;
	paginationInProgress: boolean;
	objects: OrderedMap<string, any>;
	offset: number;
	count: number;
	globalCount: number,
	searchTerm: string;
	searchStr: string;
	filters: { [k: string]: any };
	orderings: OrderingRuleType[];
	sort: OrderingRuleType[];
	requestParams: { [k: string]: string };
	pagination: boolean;
	error: boolean;
	limit: number;
	property: string;
	cancelToken: CancelTokenSource;
	page: boolean
};

export const instanceStoreRecord: Record.Factory<any> = Record({
	inProgress: false,
	paginationInProgress: false,
	objects: OrderedMap<string, any>(),
	offset: 0,
	count: null,
	globalCount: null,
	searchTerm: 'search',
	searchStr: '',
	filters: null,
	orderings: null,
	sort: null,
	requestParams: null,
	pagination: true,
	error: false,
	limit: 25,
	property: null,
	cancelToken: null,
	page: false
});

type ObjectsStoreType = {
	instances: Map<string, InstanceStoreRecordType>;
};

export type ObjectsStoreRecordType = Record<ObjectsStoreType>;

export type GlobalStore = {
	[key]: ObjectsStoreRecordType;
};

export type InstanceStoreRecordType = Record<InstanceType>;

const stateRecord: Record.Factory<ObjectsStoreType> = Record({
	instances: Map<string, InstanceStoreRecordType>(),
});

export const initialState = stateRecord();
